import { initCalculationCall } from '../common/fns'
import { dowelingCalculation, crackInjectionCalculation } from './calculationAction'
import { store } from './store'
import { $get} from '../../../utils/apis'

export const fetchStaticData =  (params) => async dispatch => {
    dispatch({ type: 'STATIC_DATA_INIT' })
    try {
    const response = await $get('/ace')
      if(response.data) {
        const [myInitial, errors] = initCalculationCall(params, response.data)

        dispatch(setInitialState(myInitial))
        dispatch(fetchStaticDataSuccess(response.data))
        if (myInitial.subApp === '0') {
          store.dispatch(dowelingCalculation(myInitial, response.data))
        } else {
          store.dispatch(crackInjectionCalculation(myInitial, response.data))
        }
      }
    } catch (error) {
      dispatch(fetchStaticDataError(error))
    }
}

export const setInitialState = (myInitial) => {
  return {
    type: 'FIELD_SWITCH_SUBAPP',
    payload: myInitial,
  }
}

export const fetchStaticDataSuccess = (data) => {
  return {
    type: 'STATIC_DATA_SUCCESS',
    payload: data,
  }
}

export const fetchStaticDataError = (error) => {
  // e.g. Error: Network Error
  return {
    type: 'STATIC_DATA_FAILURE',
    payload: {
      msgLevel: 'error',
      msgHeader: 'Network Error',
      msgBody:
        'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.',
    },
  }
}
